import { makeStyles } from '@fluentui/react-components';

const row = {
  display: 'flex',
  flow: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '24px',
  marginBottom: '5px',
};

export const usePopoverStyles = makeStyles({
  container: {
    width: '174px',
    color: '#323130',
  },
  title: {
    marginBottom: '5px',
  },
  row,
  perfEditorialRow: {
    ...row,
    height: 'auto',
    flexWrap: 'wrap',
  },
  description: {
    display: 'flex',
    marginTop: '8px',
    marginBottom: '8px',
  },
});
